import Box from '@/components/UI/box/Box';
import styles from './MidTermNeighbourhoods.module.scss';
import FilterChips from '../reusabe/filterChips/FilterChips';
import useDrawer from '@/hooks/useDrawer';
import Menu from '@/components/UI/menu/Menu';
import Drawer from '@/components/UI/drawer/Drawer';
import { useRef } from 'react';
import useDevice from '@/hooks/useDevice';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import { useForm } from 'react-hook-form';
import NeighbourhoodsList from './neighbourhoodsList/NeighbourhoodsList';
import useMidTermFilters from '@/components/search/hooks/useMidTermFilters';
export interface NeighbourhoodsData {
  village: string[] | undefined;
}
const MidTermNeighbourhoods = () => {
  const {
    setQuery,
    queries
  } = useSearchParams();
  const {
    updateQueryParams,
    clearFilters,
    extractActiveFilters,
    useSyncFormWithQuery
  } = useMidTermFilters();
  const {
    handleSubmit,
    control,
    reset,
    setValue
  } = useForm<NeighbourhoodsData>({
    defaultValues: {}
  });
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const open = isDrawerOpen('NEIGHBOURHOODS');
  const closeRef = useRef<any>(null);
  const {
    isMobile
  } = useDevice();
  useSyncFormWithQuery(queries, reset);
  const activeFilters = extractActiveFilters(queries);
  const selectedNumber = Array.isArray(activeFilters.village) ? activeFilters.village.length : 0;
  const onSubmit = form => {
    updateQueryParams(form, setQuery);
  };
  const handleResetFilter = e => {
    e.stopPropagation();
    const clearedFilter = clearFilters(queries, 'village');
    reset(clearedFilter);
    setQuery(clearedFilter);
  };
  const handleClick = () => {
    if (open) {
      drawerClose();
    } else {
      drawerOpen('NEIGHBOURHOODS');
    }
  };
  const handleClose = () => {
    drawerClose();
  };
  return <Box className={styles['mid-term-neighbourhoods-container']} data-sentry-element="Box" data-sentry-component="MidTermNeighbourhoods" data-sentry-source-file="MidTermNeighbourhoods.tsx">
      <FilterChips type="secondary" checked={!!selectedNumber} handleClick={handleClick} handleClean={handleResetFilter} label={selectedNumber ? `محله (${selectedNumber})` : 'محله'} endIcon name="midterm_neighbourhoods_filter" id="mid-term-neighbourhoods" data-sentry-element="FilterChips" data-sentry-source-file="MidTermNeighbourhoods.tsx" />
      {!isMobile ? open && <Menu ref={closeRef} id="neighbourhoods" open={open} handleClose={drawerClose} className={styles['filter-item-container']} menuButtonId="mid-term-neighbourhoods">
            <NeighbourhoodsList handleClose={drawerClose} control={control} handleSubmit={handleSubmit} onSubmit={onSubmit} handleResetFilter={handleResetFilter} handleValue={setValue} />
          </Menu> : <Drawer open={isDrawerOpen('NEIGHBOURHOODS')} onClose={handleClose} fullHeight>
          <NeighbourhoodsList handleClose={drawerClose} control={control} handleSubmit={handleSubmit} onSubmit={onSubmit} handleResetFilter={handleResetFilter} handleValue={setValue} />
        </Drawer>}
    </Box>;
};
export default MidTermNeighbourhoods;